/*
 * Module for the description for the Content Page
 */

define(["marionette", "modules/contentsSplit/content/contentNotes/contentNotesView"], function (
  Marionette,
  ContentNotesView,
) {
  var ContentNotesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "contentNotesModule";
    },
    show: function (content) {
      this.view = new ContentNotesView.contentNotesView({ model: content });
      this.showRegion(this.view);
    },
  });

  return ContentNotesController;
});
